export const downloadFileFromRemoteUrl = async ({
  fetchOptions,
  fileName,
  url,
}: {
  fetchOptions?: RequestInit;
  fileName?: string;
  url: string;
}): Promise<void> => {
  const data = await fetch(url, fetchOptions);
  const blob = await data.blob();
  const objectUrl = URL.createObjectURL(blob);
  const urlParts = url.split('/');
  const urlFileName = urlParts[urlParts.length - 1];
  downloadFileByUrl(objectUrl, fileName || urlFileName);
};

/**
 * Ask the browser to download a file from a URL.
 * @param url The URL of the file to download.
 * @param fileName A name to suggest to the browser for the downloaded file. The
 * browser may ignore this value, especially if the resource provides a
 * `Content-Disposition` header with its own preferred name. If not given, the
 * browser will pick one on its own. Becomes the value of a [`download`
 * attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#download).
 */
export const downloadFileByUrl = (url: string, fileName = ''): void => {
  const link = document.createElement('a');
  link.download = fileName;
  link.href = url;
  link.click();
  link.remove();
};
